export default __webpack_public_path__ + "static/media/news1.9e617218.png";